module.exports = __webpack_public_path__ + "img/pom-pom-at-home.fed6c88.jpg";